module.exports = __webpack_public_path__ + "img/question.a9165a46.svg";